import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { MapPin, Phone, Envelope } from 'phosphor-react';
import { Avatar, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import { closeYourTeamModal } from '../../../../actions/dashboard';
import { abbreviateState } from '../../../../lib/helpers';
import GeoLocationClient from '../../../../services/GeoLocationClient';
import ResponsiveDialog from '../../../utility/ResponsiveDialog';
import styles from '../../../../styles/sass/components/YourTeam.module.scss';

const style = {
  icon: {
    marginRight: 10,
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
  },
};

interface Props {
  agent: any;
  yourTeamModalOpen: boolean;
  dispatch: Function;
}

export const YourTeamModal: React.FC<Props> = ({
  agent,
  dispatch,
  yourTeamModalOpen,
}) => {
  const [coordinates, setCoordinates] = useState<string>('');
  const [contactNumber, setContactNumber] = useState<string>('');

  const contactByEmail = () => {
    const win: any = window.open(`mailto:${agent.email}`, '_blank');
    win.focus();
  };

  useEffect(() => {
    if (agent && agent.city && agent.state) {
      const overallLocation = `${agent.city}, ${abbreviateState(agent.state)}`;
      const LocationClient = new GeoLocationClient();
      LocationClient.fetchCoordsForCity(overallLocation, (response: any) => {
        if (response) {
          const { latitude, longitude } = response;
          setCoordinates(`${latitude},${longitude}`);
        }
      });
    }
    if (agent && agent.cellPhoneNumber) {
      const contactNumber = agent.cellPhoneNumber.replace(/-/g, '');
      setContactNumber(contactNumber);
    }
  }, [agent]);

  if (isEmpty(agent)) {
    return null;
  }

  return (
    <ResponsiveDialog
      open={yourTeamModalOpen}
      onClose={() => dispatch(closeYourTeamModal())}
      className={'your-team-dialog'}
      buttonClassName={'team-dialog-btn-container'}
      closeIconStyles={{
        width: '32',
        height: '32',
      }}
    >
      <div className={styles.modalContainer}>
        <div className={styles.agentPhoto}>
          <Avatar
            src={agent.picture}
            style={{
              width: 80,
              height: 80,
            }}
          />
        </div>
        <div className={styles.name}>
          <span>
            {agent.firstName} {agent.lastName}
          </span>
        </div>
        <div className={styles.role}>
          <span>
            {agent.title === 'Client Success Manager'
              ? 'Experience Manager'
              : agent.title}
          </span>
        </div>

        <div className={styles.details}>
          <div className={styles.location}>
            <Link
              href={{
                pathname: '/search',
                query: { location: coordinates },
              }}
            >
              <a
                aria-label="Agent Location"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MapPin size={24} color="#636363" weight="regular" />
                <span>
                  {agent.city}, {abbreviateState(agent.state)}
                </span>
              </a>
            </Link>
          </div>
          <div className={styles.location}>
            <Link href={`tel:${contactNumber}`}>
              <a aria-label="Agent Phone Number">
                <Phone size={24} color="#636363" weight="regular" />
                <span>{agent.cellPhoneNumber}</span>
              </a>
            </Link>
          </div>
        </div>

        {agent.blurb ? (
          <div className={styles.blurb}>{agent.blurb}</div>
        ) : (
          <div style={{ margin: 10 }} />
        )}

        <div className={styles.contactButtons}>
          <Button
            onClick={contactByEmail}
            className={styles.emailButton}
            style={style.button}
          >
            <Envelope
              size={24}
              color="#FFFFFF"
              weight="fill"
              style={style.icon}
            />
            <p>Email {agent.firstName}</p>
          </Button>
        </div>
      </div>
    </ResponsiveDialog>
  );
};

const mapStateToProps = (state: any) => ({
  yourTeamModalOpen: state.dashboard.yourTeamModalOpen,
});

export default connect(mapStateToProps)(YourTeamModal);
